import React from 'react';
import Icon from '../../../components/AppIcon';

const ActivityTimelineItem = ({ activity, isLast }) => {
  const getActivityIcon = (type) => {
    const icons = {
      'application': 'Send',
      'profile': 'User',
      'interview': 'Calendar',
      'document': 'FileText',
      'message': 'MessageSquare'
    };
    return icons?.[type] || 'Activity';
  };

  const getActivityColor = (type) => {
    const colors = {
      'application': 'var(--color-primary)',
      'profile': 'var(--color-secondary)',
      'interview': 'var(--color-success)',
      'document': 'var(--color-accent)',
      'message': 'var(--color-warning)'
    };
    return colors?.[type] || 'var(--color-muted-foreground)';
  };

  const formatTime = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffTime = Math.abs(now - date);
    const diffMinutes = Math.floor(diffTime / (1000 * 60));
    const diffHours = Math.floor(diffTime / (1000 * 60 * 60));
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    if (diffMinutes < 60) return `${diffMinutes} minutes ago`;
    if (diffHours < 24) return `${diffHours} hours ago`;
    if (diffDays === 1) return 'Yesterday';
    if (diffDays < 7) return `${diffDays} days ago`;
    return date?.toLocaleDateString('en-IN', { day: '2-digit', month: 'short' });
  };

  return (
    <div className="flex gap-4">
      <div className="flex flex-col items-center">
        <div 
          className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0"
          style={{ backgroundColor: `${getActivityColor(activity?.type)}15` }}
        >
          <Icon 
            name={getActivityIcon(activity?.type)} 
            size={18} 
            color={getActivityColor(activity?.type)} 
          />
        </div>
        {!isLast && (
          <div className="w-0.5 h-full bg-border mt-2" />
        )}
      </div>
      <div className="flex-1 pb-6">
        <h5 className="text-sm font-medium text-card-foreground mb-1">
          {activity?.title}
        </h5>
        <p className="text-sm text-muted-foreground mb-2 line-clamp-2">
          {activity?.description}
        </p>
        <span className="text-xs text-muted-foreground">
          {formatTime(activity?.timestamp)}
        </span>
      </div>
    </div>
  );
};

export default ActivityTimelineItem;